{
  "id": "loki",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Loki",
    "en": "Loki"
  },
  "icon": "gods/loki",
  "portrait": "gods/loki-portrait",
  "modifiers": [
    {
      "target": "builderRate",
      "op": "pct",
      "value": 0.1,
      "note": "ArchaicAgeLoki: BuildRate +10% BasePercent on the builder (Norse infantry, heroes, Godi); Gatherers and Dwarves do not get it.",
      "scope": {
        "ids": ["berserk", "hersir", "godi", "hirdman", "throwing-axeman", "huskarl"]
      }
    },
    {
      "target": "cost",
      "op": "pct",
      "value": -0.5,
      "scope": {
        "ids": ["ox-cart"]
      },
      "note": "OxCartBuilding food and wood cost x0.5 BasePercent: 20 food + 20 wood."
    },
    {
      "target": "promotionCost",
      "op": "pct",
      "value": -0.5,
      "scope": {
        "ids": ["gatherer", "dwarf"]
      },
      "note": "ArchaicAgeLoki: VillagerNorseToBerserk and VillagerDwarfToBerserk food and gold cost x0.5 BasePercent."
    }
  ],
  "powers": ["spy"],
  "minors": {
    "classical": ["heimdall", "forseti"],
    "heroic": ["bragi", "njord"],
    "mythic": ["hel", "tyr"]
  },
  "unlocks": ["eyes-in-the-forest"],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "ArchaicAgeLoki: Spy (cooldown 30); infantry/Godi build x1.1; Ox Cart cost x0.5; Berserk transform (VillagerNorse/DwarfToBerserk) cost x0.5 BasePercent (not modelled); +10% bonus damage for Hersir, Godi, Hirdman, Throwing Axeman, Huskarl and Raiding Cavalry against their counters. Not modelled: bonusunitspawning (major_gods.xml) - damage by Hersirs (0.5), Godi (0.15) and human soldiers (0.15) fills a meter that spawns a random myth unit when it reaches its cost (favor counted x10); Kraken and Jormun Elver excluded."
  }
}
